module.exports = __webpack_public_path__ + "img/article-default-img.a9e0c093.png";